import styled from 'styled-components';

const COBALT = '#0B4598';
const GREEN = '#13CA82';

export const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e3e8f0;
  border-radius: 12px;
  padding: 16px;
  margin: 12px 0;
  box-shadow: 0 1px 4px rgba(11, 69, 152, 0.08);
`;

export const Title = styled.h3`
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
  color: ${COBALT};
`;

export const Explainer = styled.p`
  margin: 0 0 14px;
  font-size: 13px;
  line-height: 1.4;
  color: #5b6878;
`;

export const Subtitle = styled.div`
  font-size: 12px;
  color: #8a97a8;
  margin-bottom: 2px;
`;

export const CodeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-top: 1px solid #eef1f6;
`;

export const CodeValue = styled.div`
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: ${COBALT};
`;

export const ShareRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-top: 1px solid #eef1f6;
`;

export const ShareLabel = styled.div`
  font-size: 12px;
  color: #8a97a8;
  margin-bottom: 2px;
`;

export const ShareLink = styled.a`
  font-size: 13px;
  color: ${COBALT};
  word-break: break-all;
`;

export const CopyButton = styled.button`
  flex: 0 0 auto;
  border: 1px solid ${COBALT};
  background: ${COBALT};
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;

  &:active {
    opacity: 0.85;
  }
`;

export const CreditsBadge = styled.div`
  margin-top: 12px;
  padding: 10px 12px;
  background: rgba(19, 202, 130, 0.1);
  border-radius: 8px;
  font-size: 14px;
  color: #0a7a4f;

  strong {
    color: ${GREEN};
    font-size: 16px;
  }
`;

export const ActivityCounts = styled.dl`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
  padding: 12px 0 0;
  border-top: 1px solid #eef1f6;

  dt {
    color: #5b6878;
    font-size: 13px;
    line-height: 1.4;
  }

  dd {
    margin: 4px 0 0;
    color: ${COBALT};
    font-size: 22px;
    font-weight: 700;
  }
`;

export const ErrorText = styled.p`
  font-size: 13px;
  color: #fb7672;
  margin: 8px 0 0;
`;
